module.exports = __webpack_public_path__ + "static/media/gen_dra_str_str.33413d9a.png";